import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import { useIdentity } from '../../../Authentication/Authentication.hooks';
import { linksV2, linksWithHashedEmail } from '../../Account.utils';
import { BUILD } from '../../../../util/const';
import {
  shopify_base_url,
  platform_base_url,
  vercel_base_url
} from '../../../../util/config';
import { post } from '../../../../util/request';

import * as Styled from './AccountNavSettings.styled';

/**
 * Displays Account settings in Account Navigation Dialog
 */
const AccountNavSettings = ({ onRequestClose, withReactRouter }) => {
  const { user, eraseUser } = useIdentity();
  const userCountry = user.locale.country;

  const settingsLinks =
    userCountry === 'US'
      ? linksV2
      : linksV2.filter((link) => link.path !== '/account/settings/addresses');

  const base_url = BUILD === 'shopify' ? vercel_base_url : '';
  const LinkComponent = BUILD === 'shopify' ? 'a' : Link;

  const handleLogout = async (e) => {
    e.preventDefault();
    const { href } = e.currentTarget;

    await post(`${platform_base_url}/v2/identity/sign-out`, null, {
      credentials: 'include'
    });

    eraseUser();
    onRequestClose();

    window.location = href;
  };

  return (
    <Styled.AccountNavSettings>
      <Styled.SettingsLinksContainer>
        {settingsLinks.map((link) => (
          <Styled.Link
            as={!withReactRouter ? LinkComponent : undefined}
            href={`${base_url}${link.path}`}
            to={link.path}
            key={link.path}
            path={link.path}
            onClick={onRequestClose}
          >
            <Styled.LinkCard title={link.name} description={link.description} />
          </Styled.Link>
        ))}
        {user.hashedEmail &&
          linksWithHashedEmail.map((link) => (
            <Styled.Link
              as={!withReactRouter ? LinkComponent : undefined}
              href={`${base_url}${link.path}`}
              to={link.path}
              key={link.path}
              path={link.path}
              onClick={onRequestClose}
            >
              <Styled.LinkCard
                title={link.name}
                description={link.description}
              />
            </Styled.Link>
          ))}
      </Styled.SettingsLinksContainer>
      <Styled.LogOut
        as="a"
        href={`${shopify_base_url}/account/logout`}
        onClick={handleLogout}
      >
        Log Out
      </Styled.LogOut>
    </Styled.AccountNavSettings>
  );
};

AccountNavSettings.propTypes = {
  /**
   * A function that is called when `AccountNavDialog` is requesting to close.
   */
  onRequestClose: PropTypes.func.isRequired,
  /**
   * `true` to render react router links
   *  when the component is rendered within a SPA such as Account
   *  otherwise render a normal anchor tag to navigate to the SPA
   */
  withReactRouter: PropTypes.bool
};

AccountNavSettings.defaultProps = {
  withReactRouter: false
};

export default AccountNavSettings;
